module.exports = __webpack_public_path__ + "img/nogo-vented-pipe-min.5f7171e0.jpg";